import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import {  PicturesVideoContainerProps } from "../../interfaces/containers";
import PicturesVideo from "../../components/SellModal/PicturesVideo/PicturesVideo";
import { setImages, postPublicationsImages, deletePublicationImage, cleanDeleteImage } from "../../actions/salePost";

function mapStateToProps(state: PicturesVideoContainerProps) {
    return{
        imagesVideos: state.salePost.imagesVideos,
        plate: state.salePost.plate,
        isFoundPlate: state.salePost.isFoundPlate,
        fetchingDeleteImage: state.salePost.fetchingDeleteImage
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        postPublicationsImages,
        deletePublicationImage,
        cleanDeleteImage,
        setImages
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(PicturesVideo);